// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3-XZs","signatureBlock":"Footer_signatureBlock__3L9EN","signature":"Footer_signature__3-mBh"};